export default "__VITE_ASSET__cface780__"